export const widgetDragHandleClass = "widget-drag-handle";
export const widgetActionsMenuClass = "widget-actions-menu";
export const widgetActionsDropdownOpenClass = "widget-actions-dropdown-open";
